import SpreeAPI from "./spree/api/main"

SpreeAPI.ready(function($) {
  'use strict';
  $('#contracts').find('button.js_input_number_plus').on('click', function(){
    var $quant = $(this).closest('.js_bigger_radio_outer').children('input');
    var $quantVal = Number($quant.val()) + 1;
    if (Number($quant.attr('max')) === Number($quant.val())) {
      $quantVal = Number($quant.val());
    }
    changeTotal($quant, $quantVal);
  });

  $('#contracts').find('button.js_input_number_minus').on('click', function(){
    var $quant = $(this).closest('.js_bigger_radio_outer').children('input');
    var $quantVal = Number($quant.val()) - 1;
    if (Number($quant.attr('min')) === Number($quant.val())) {
      $quantVal = Number($quant.val());
    }
    changeTotal($quant, $quantVal);
  });

  $('#contracts').find('.js_bigger_radio_trigger').on('click', function (event) {
    if ($(event.target).parent('.js_bigger_radio_outer').length == 0) {
      var $variant = $(this).parent('li').attr('class');
      var $point = $(this).closest('form').find('.p_bottom_submit_info');
      $point.children('.p_bottom_submit_price').hide();
      $point.find('.' + $variant).parent('.p_bottom_submit_price').show();
    }
  });

  function changeTotal($quant, $quantVal){
    var $price = Number($quant.closest('li').find('span.base').text().replace(/,/g,''));
    var $total = $price * $quantVal;
    var $variant = $quant.closest('li').attr('class');
    var $point = $quant.closest('form').find('.p_bottom_submit_info').find('.' + $variant);
    $point.find('span.regular').text($total.toLocaleString());
    $point.find('span.divine').text(($total * 12).toLocaleString());
  }
});
